export default function sortPackages(packages) {
	return packages.sort((a, b) => {
		const [, r1] = a.resultId.split('.');
		const [, r2] = b.resultId.split('.');
		return parseInt(r1, 10) - parseInt(r2, 10);
	});
}
